import { Injectable } from '@angular/core';

@Injectable()
export class BasketTools {
    public basketList: any;
    constructor() { 
        this.basketList = new Array();
    }

    public clear() {
        this.basketList.length = 0;
    }
    
    public add(aData) {
        let witem;
        witem = this.find(aData.doc_docid);
        if (witem === undefined) {
            this.basketList.push(aData);
        };
    }

    public remove(aId) {
        this.basketList = this.basketList.filter(item => {
            return item.doc_docid !== aId;
        });
    }

    private find(id) {
        return this.basketList.find((item) => {
            return item.doc_docid === id;
        })
    }

}

